import { ADD_TOAST, REMOVE_TOAST } from "./ToastsAction";

export const initialState = {
    items: [],
};

export default function toastsReducer(state = initialState, action) {
    switch (action.type) {
        case ADD_TOAST:
            return {
                ...state,
                items: [
                    ...state.items,
                    action.payload
                ],
            };
        case REMOVE_TOAST: {
            const toastId = action.payload;
            return {
                ...state,
                items: state.items.filter((model) => model.id !== toastId),
            };
        }
        default:
            return state;
    }
}